import * as React from "react";
import { MoveMode } from "./MoveMode";
import * as styles from "./MoveNode.css";

const moveOptions = [
    {
        value: MoveMode.NodeAndChildren,
        label: "Move this node and its children",
    },
    {
        value: MoveMode.AllChildren,
        label: "Move all its children",
    },
    {
        value: MoveMode.AllChildrenAndDelete,
        label: "Move all its children, then delete this node",
    },
];

export function MoveModeSelector({
    descendantCount,
    nodeMoveDisabled,
    moveMode,
    setMoveMode,
}: {
    descendantCount: number;
    nodeMoveDisabled: boolean;
    moveMode: MoveMode;
    setMoveMode: (moveMode: MoveMode) => void;
}) {
    return (
        <div
            className={styles.moveModes}
            role="radiogroup"
            aria-labelledby="workflowMoveModeLabel"
        >
            <div
                id="workflowMoveModeLabel"
                className={styles.moveModeLabel}
            >
                What should move?
            </div>
            {moveOptions.map((option) => {
                const movesDescendantsOnly =
                    option.value !== MoveMode.NodeAndChildren;
                const isDisabled =
                    (movesDescendantsOnly && descendantCount === 0) ||
                    (option.value === MoveMode.NodeAndChildren &&
                        nodeMoveDisabled);

                return (
                    <label className={styles.moveMode} key={option.value}>
                        <input
                            type="radio"
                            name="workflowMoveMode"
                            value={option.value}
                            checked={moveMode === option.value}
                            disabled={isDisabled}
                            onChange={() => setMoveMode(option.value)}
                        />
                        <span>{option.label}</span>
                        {movesDescendantsOnly ? (
                            <small>
                                {descendantCount}{" "}
                                {descendantCount === 1
                                    ? "descendant"
                                    : "descendants"}
                            </small>
                        ) : null}
                    </label>
                );
            })}
        </div>
    );
}
